"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var colors_1 = require("./colors");
exports.light = {
    color1: colors_1.white1,
    color2: colors_1.white2,
    color3: colors_1.white3,
    color4: colors_1.grey1,
    color5: colors_1.grey2,
    color6: colors_1.grey3,
    color7: colors_1.grey4,
    color8: colors_1.grey5,
    color9: colors_1.grey6,
    color10: colors_1.grey7,
    color11: colors_1.grey8,
    color12: colors_1.grey9,
    color13: colors_1.black3,
    color14: colors_1.black2,
    color15: colors_1.black1,
    background1: colors_1.white1,
    background2: colors_1.white3,
    text1: colors_1.black1,
    text2: colors_1.grey6,
    text3: colors_1.grey2,
    default: colors_1.grey4,
    hover: colors_1.grey1,
    active: colors_1.black1,
    selected: colors_1.black1,
};
exports.dark = {
    color1: colors_1.black1,
    color2: colors_1.black2,
    color3: colors_1.black3,
    color4: colors_1.grey9,
    color5: colors_1.grey8,
    color6: colors_1.grey7,
    color7: colors_1.grey6,
    color8: colors_1.grey5,
    color9: colors_1.grey4,
    color10: colors_1.grey3,
    color11: colors_1.grey2,
    color12: colors_1.grey1,
    color13: colors_1.white3,
    color14: colors_1.white2,
    color15: colors_1.white1,
    background1: colors_1.black1,
    background2: colors_1.black3,
    text1: colors_1.white1,
    text2: colors_1.grey4,
    text3: colors_1.grey8,
    default: colors_1.grey6,
    hover: colors_1.grey9,
    active: colors_1.white1,
    selected: colors_1.white1,
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGhlbWUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvdGhlbWUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQSxtQ0FnQmtCO0FBRUwsUUFBQSxLQUFLLEdBQUc7SUFDbkIsTUFBTSxFQUFFLGVBQU07SUFDZCxNQUFNLEVBQUUsZUFBTTtJQUNkLE1BQU0sRUFBRSxlQUFNO0lBQ2QsTUFBTSxFQUFFLGNBQUs7SUFDYixNQUFNLEVBQUUsY0FBSztJQUNiLE1BQU0sRUFBRSxjQUFLO0lBQ2IsTUFBTSxFQUFFLGNBQUs7SUFDYixNQUFNLEVBQUUsY0FBSztJQUNiLE1BQU0sRUFBRSxjQUFLO0lBQ2IsT0FBTyxFQUFFLGNBQUs7SUFDZCxPQUFPLEVBQUUsY0FBSztJQUNkLE9BQU8sRUFBRSxjQUFLO0lBQ2QsT0FBTyxFQUFFLGVBQU07SUFDZixPQUFPLEVBQUUsZUFBTTtJQUNmLE9BQU8sRUFBRSxlQUFNO0lBQ2YsV0FBVyxFQUFFLGVBQU07SUFDbkIsV0FBVyxFQUFFLGVBQU07SUFDbkIsS0FBSyxFQUFFLGVBQU07SUFDYixLQUFLLEVBQUUsY0FBSztJQUNaLEtBQUssRUFBRSxjQUFLO0lBQ1osT0FBTyxFQUFFLGNBQUs7SUFDZCxLQUFLLEVBQUUsY0FBSztJQUNaLE1BQU0sRUFBRSxlQUFNO0lBQ2QsUUFBUSxFQUFFLGVBQU07Q0FDakIsQ0FBQztBQUNXLFFBQUEsSUFBSSxHQUFHO0lBQ2xCLE1BQU0sRUFBRSxlQUFNO0lBQ2QsTUFBTSxFQUFFLGVBQU07SUFDZCxNQUFNLEVBQUUsZUFBTTtJQUNkLE1BQU0sRUFBRSxjQUFLO0lBQ2IsTUFBTSxFQUFFLGNBQUs7SUFDYixNQUFNLEVBQUUsY0FBSztJQUNiLE1BQU0sRUFBRSxjQUFLO0lBQ2IsTUFBTSxFQUFFLGNBQUs7SUFDYixNQUFNLEVBQUUsY0FBSztJQUNiLE9BQU8sRUFBRSxjQUFLO0lBQ2QsT0FBTyxFQUFFLGNBQUs7SUFDZCxPQUFPLEVBQUUsY0FBSztJQUNkLE9BQU8sRUFBRSxlQUFNO0lBQ2YsT0FBTyxFQUFFLGVBQU07SUFDZixPQUFPLEVBQUUsZUFBTTtJQUNmLFdBQVcsRUFBRSxlQUFNO0lBQ25CLFdBQVcsRUFBRSxlQUFNO0lBQ25CLEtBQUssRUFBRSxlQUFNO0lBQ2IsS0FBSyxFQUFFLGNBQUs7SUFDWixLQUFLLEVBQUUsY0FBSztJQUNaLE9BQU8sRUFBRSxjQUFLO0lBQ2QsS0FBSyxFQUFFLGNBQUs7SUFDWixNQUFNLEVBQUUsZUFBTTtJQUNkLFFBQVEsRUFBRSxlQUFNO0NBQ2pCLENBQUMifQ==


//////////////////
// WEBPACK FOOTER
// ./node_modules/@riiid/santa-closet-web/theme.js
// module id = 24
// module chunks = 0